// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"8yOTG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _vue = require("vue");
var _buefy = require("buefy");
var _buefyDefault = parcelHelpers.interopDefault(_buefy);
var _utilsJs = require("./ts/utils.js");
var _signInVue = require("./pages/SignIn.vue");
var _signInVueDefault = parcelHelpers.interopDefault(_signInVue);
var app = (0, _vue.createApp)((0, _signInVueDefault.default));
//@ts-ignore
app.use((0, _buefyDefault.default), (0, _utilsJs.buefyConfig));
app.mount('#app');
(0, _utilsJs.keepalive)(false);

},{"vue":"2IF1a","buefy":"czVrE","./ts/utils.js":"13wIX","./pages/SignIn.vue":"34wXx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"34wXx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("f921571fbe264b51");
    if (script.__esModule) script = script.default;
    script.render = require("d6f38f597f37f003").render;
    require("a8d134346a4ec926").default(script);
    script.__scopeId = 'data-v-c20ccc';
    script.__file = "SignIn.vue";
};
initialize();
exports.default = script;

},{"f921571fbe264b51":"2shw1","d6f38f597f37f003":"bJIMw","a8d134346a4ec926":"99m3x","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2shw1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vue = require("vue");
var _basicLayoutVue = require("../layouts/BasicLayout.vue");
var _basicLayoutVueDefault = parcelHelpers.interopDefault(_basicLayoutVue);
var _signInContentVue = require("./SignInContent.vue");
var _signInContentVueDefault = parcelHelpers.interopDefault(_signInContentVue);
exports.default = /*@__PURE__*/ (0, _vue.defineComponent)({
    __name: 'SignIn',
    setup: function(__props, _a) {
        var __expose = _a.expose;
        __expose();
        var __returned__ = {
            BasicLayout: (0, _basicLayoutVueDefault.default),
            SignInContent: (0, _signInContentVueDefault.default)
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
});

},{"vue":"2IF1a","../layouts/BasicLayout.vue":"dhkFo","./SignInContent.vue":"jss1B","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dhkFo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("7043a24cccffcafd");
    if (script.__esModule) script = script.default;
    script.render = require("a3596e50552b1f88").render;
    script.__cssModules = require("ad0cdc1243cb4e2b").default;
    require("2e284ae458b64643").default(script);
    script.__scopeId = 'data-v-fbc404';
    script.__file = "BasicLayout.vue";
};
initialize();
exports.default = script;

},{"7043a24cccffcafd":"kShY2","a3596e50552b1f88":"5V3O1","ad0cdc1243cb4e2b":"evMO7","2e284ae458b64643":"gMT6U","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kShY2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vue = require("vue");
var _eloUiCss = require("@elo/ui-buefy-v3/dist/elo-ui.css");
var _fontEloSansPro = require("@elo/font-elo-sans-pro");
var _eIconsCss = require("../css/e-icons.css");
var _utils = require("../ts/utils"); // EAUTH2-33
exports.default = /*@__PURE__*/ (0, _vue.defineComponent)({
    __name: 'BasicLayout',
    setup: function(__props, _a) {
        var __expose = _a.expose;
        __expose();
        document.body.style.backgroundImage = "url('".concat((0, _utils.API_URL), "/branding/background')");
        var license = (0, _vue.ref)('ELO Digital Office');
        (0, _utils.fetchJson)((0, _utils.API_URL) + '/status').then(function(status) {
            license.value = status.license;
        }).catch(function(e) {
            license.value = "Failed to get Auth2 Plugin status: ".concat(e);
        });
        var __returned__ = {
            license: license,
            Suspense: (0, _vue.Suspense)
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
});

},{"vue":"2IF1a","@elo/ui-buefy-v3/dist/elo-ui.css":"81LGK","@elo/font-elo-sans-pro":"omINW","../css/e-icons.css":"fLMWM","../ts/utils":"13wIX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"81LGK":[function() {},{}],"omINW":[function() {},{}],"fLMWM":[function() {},{}],"5V3O1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = {
    class: "boxed-container"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_loading = (0, _vue.resolveComponent)("b-loading");
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), null, [
        _cache[1] || (_cache[1] = (0, _vue.createElementVNode)("header", null, null, -1)),
        (0, _vue.createElementVNode)("main", _hoisted_1, [
            _cache[0] || (_cache[0] = (0, _vue.createElementVNode)("div", {
                class: "logos"
            }, [
                (0, _vue.createElementVNode)("img", {
                    class: "logo-primary",
                    src: '../de.elo.ix.plugin.rest/auth2/branding/logo-primary',
                    alt: "logo-primary"
                }),
                (0, _vue.createElementVNode)("img", {
                    class: "logo-secondary",
                    src: '../de.elo.ix.plugin.rest/auth2/branding/logo-secondary',
                    alt: "logo-secondary"
                })
            ], -1)),
            ((0, _vue.openBlock)(), (0, _vue.createBlock)((0, _vue.Suspense), null, {
                fallback: (0, _vue.withCtx)(()=>[
                        (0, _vue.createVNode)(_component_b_loading)
                    ]),
                default: (0, _vue.withCtx)(()=>[
                        (0, _vue.renderSlot)(_ctx.$slots, "default")
                    ]),
                _: 3
            }))
        ]),
        (0, _vue.createElementVNode)("footer", null, (0, _vue.toDisplayString)($setup.license), 1)
    ], 64);
}

},{"vue":"2IF1a","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"evMO7":[function() {},{}],"gMT6U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jss1B":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("d6b71b9ac3d632cb");
    if (script.__esModule) script = script.default;
    script.render = require("d85bdebc6e9e6e41").render;
    script.__cssModules = require("b1080903fc0fb5c3").default;
    require("b55911dd194edfe2").default(script);
    script.__scopeId = 'data-v-c58d5b';
    script.__file = "SignInContent.vue";
};
initialize();
exports.default = script;

},{"d6b71b9ac3d632cb":"6axhU","d85bdebc6e9e6e41":"bVLFq","b1080903fc0fb5c3":"gR8fS","b55911dd194edfe2":"hT4bd","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6axhU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vue = require("vue");
var _utils = require("../ts/utils");
var _passwordBasedLoginVue = require("../components/PasswordBasedLogin.vue");
var _passwordBasedLoginVueDefault = parcelHelpers.interopDefault(_passwordBasedLoginVue);
var _translations = require("../ts/translations");
var _localeSelectorVue = require("../components/LocaleSelector.vue");
var _localeSelectorVueDefault = parcelHelpers.interopDefault(_localeSelectorVue);
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v1) {
            return step([
                n,
                v1
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
exports.default = /*@__PURE__*/ (0, _vue.defineComponent)({
    __name: 'SignInContent',
    setup: function(__props_1, _a) {
        return __awaiter(this, arguments, void 0, function(__props, _b) {
            function fetchRef(url) {
                return __awaiter(this, void 0, void 0, function() {
                    var json;
                    return __generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                return [
                                    4 /*yield*/ ,
                                    (0, _utils.fetchJson)(url)
                                ];
                            case 1:
                                json = _a.sent();
                                return [
                                    2 /*return*/ ,
                                    (0, _vue.ref)(json)
                                ];
                        }
                    });
                });
            }
            function signInWith(providerId) {
                window.location.href = "".concat((0, _utils.API_URL), "/sign-in?provider=").concat(encodeURIComponent(providerId), "&timezone=").concat(encodeURIComponent(timezone.value));
            }
            function loginIxSSO() {
                return __awaiter(this, void 0, void 0, function() {
                    var res, initSessionRes, _a, _b, _c, _d;
                    return __generator(this, function(_e) {
                        switch(_e.label){
                            case 0:
                                // see EAUTH2-16
                                console.log("Signing in using legacy SSO");
                                waitForResponse.value = true;
                                return [
                                    4 /*yield*/ ,
                                    fetch('../../bypsauth/auth?streamversion=9.00.000.000&responseformat=byps-json&language=' + (0, _translations.getSelectedLocale)())
                                ];
                            case 1:
                                res = _e.sent();
                                waitForResponse.value = false;
                                if (!res.ok) return [
                                    3 /*break*/ ,
                                    5
                                ];
                                console.log("Signed in with SSO successfully");
                                return [
                                    4 /*yield*/ ,
                                    fetch("".concat((0, _utils.API_URL), "/init-session"), {
                                        method: 'POST',
                                        headers: {
                                            'Accept': 'application/json',
                                            'Content-Type': 'application/json'
                                        },
                                        body: JSON.stringify({
                                            locale: (0, _translations.getSelectedLocale)(),
                                            timezone: (0, _utils.getTimezone)()
                                        })
                                    })
                                ];
                            case 2:
                                initSessionRes = _e.sent();
                                if (!!initSessionRes.ok) return [
                                    3 /*break*/ ,
                                    4
                                ];
                                console.warn('Failed to initialize session options after SSO');
                                _b = (_a = console).warn;
                                return [
                                    4 /*yield*/ ,
                                    res.text()
                                ];
                            case 3:
                                _b.apply(_a, [
                                    _e.sent()
                                ]);
                                _e.label = 4;
                            case 4:
                                // To resume the redirection flow to the client (possibly code exchange flow)
                                window.location.href = (0, _utils.API_URL) + "/check-roles";
                                return [
                                    3 /*break*/ ,
                                    7
                                ];
                            case 5:
                                console.warn('Failed to sign-in with SSO');
                                _d = (_c = window).alert;
                                return [
                                    4 /*yield*/ ,
                                    res.text()
                                ];
                            case 6:
                                _d.apply(_c, [
                                    _e.sent()
                                ]);
                                _e.label = 7;
                            case 7:
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }
            /**
             * Continue sign-in flow after successful password-based login.
             */ function onLoginWithPassword() {
                return __awaiter(this, void 0, void 0, function() {
                    return __generator(this, function(_a) {
                        console.log("Continue sign-in flow...");
                        // To resume the redirection flow to the client (possibly code exchange flow)
                        window.location.href = (0, _utils.API_URL) + "/check-roles";
                        return [
                            2 /*return*/ 
                        ];
                    });
                });
            }
            var __temp, __restore, error, timezone, signInChoices, currentLocale, ui_locales, newLocale_1, res, selectedLocale, waitForResponse, errorMessageSSO, hasProviders, __returned__;
            var _c, _d, _e, _f, _g;
            var _h;
            var __expose = _b.expose;
            return __generator(this, function(_j) {
                switch(_j.label){
                    case 0:
                        __expose();
                        if ((0, _utils.isInsideIFrame)()) {
                            error = 'Authentication within an IFrame is forbidden for security reasons. Please use `?display=popup` to trigger authentication in a popup.';
                            window.alert(error);
                            throw error;
                        }
                        timezone = (0, _vue.ref)((0, _utils.getTimezone)());
                        _c = (0, _vue.withAsyncContext)(function() {
                            return fetchRef((0, _utils.API_URL) + '/sign-in-choices');
                        }), __temp = _c[0], __restore = _c[1];
                        return [
                            4 /*yield*/ ,
                            __temp
                        ];
                    case 1:
                        signInChoices = (__temp = _j.sent(), __restore(), __temp);
                        currentLocale = (0, _translations.getSelectedLocale)();
                        ui_locales = (_h = signInChoices.value.ui_locales) !== null && _h !== void 0 ? _h : (0, _translations.ELO_LOCALES);
                        if (!(ui_locales && ui_locales.length > 0 && !ui_locales.includes(currentLocale))) return [
                            3 /*break*/ ,
                            3
                        ];
                        console.log("Selecting another locale due to `ui_locales` constraint: ".concat(ui_locales));
                        newLocale_1 = (0, _translations.pickLocaleFrom)(ui_locales);
                        console.log("Locale switching: ".concat(currentLocale, " => ").concat(newLocale_1));
                        _d = (0, _vue.withAsyncContext)(function() {
                            return (0, _translations.setLocale)(newLocale_1);
                        }), __temp = _d[0], __restore = _d[1];
                        return [
                            4 /*yield*/ ,
                            __temp
                        ];
                    case 2:
                        _j.sent(), __restore();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 3:
                        _e = (0, _vue.withAsyncContext)(function() {
                            return (0, _translations.loadMessages)();
                        }), __temp = _e[0], __restore = _e[1];
                        return [
                            4 /*yield*/ ,
                            __temp
                        ];
                    case 4:
                        _j.sent(), __restore();
                        _j.label = 5;
                    case 5:
                        if (!(!signInChoices.value.client_id && window.location.search)) return [
                            3 /*break*/ ,
                            7
                        ];
                        _f = (0, _vue.withAsyncContext)(function() {
                            return fetch("".concat((0, _utils.API_URL), "/revalidate-params").concat(window.location.search));
                        }), __temp = _f[0], __restore = _f[1];
                        return [
                            4 /*yield*/ ,
                            __temp
                        ];
                    case 6:
                        res = (__temp = _j.sent(), __restore(), __temp);
                        if (res.ok) console.log('Validated search parameters successfully');
                        else {
                            console.error('Invalid URL parameters', res);
                            window.alert('Invalid URL parameters');
                        }
                        _j.label = 7;
                    case 7:
                        selectedLocale = (0, _vue.ref)((0, _translations.getSelectedLocale)());
                        waitForResponse = (0, _vue.ref)(false);
                        if (signInChoices.value.provider) {
                            console.log("Signing in using provider \"".concat(signInChoices.value.provider));
                            window.location.href = "".concat((0, _utils.API_URL), "/sign-in?provider=").concat(encodeURIComponent(signInChoices.value.provider), "&timezone=").concat(encodeURIComponent(timezone.value));
                        }
                        if (!(signInChoices.value.ixSsoEnabled && !signInChoices.value.enablePasswordLogin && (0, _utils.isEmpty)(signInChoices.value.providerLabels))) return [
                            3 /*break*/ ,
                            9
                        ];
                        _g = (0, _vue.withAsyncContext)(function() {
                            return loginIxSSO();
                        }), __temp = _g[0], __restore = _g[1];
                        return [
                            4 /*yield*/ ,
                            __temp
                        ];
                    case 8:
                        // no other choice than legacy SSO? => trigger it directly
                        _j.sent(), __restore();
                        _j.label = 9;
                    case 9:
                        errorMessageSSO = (0, _vue.ref)('');
                        hasProviders = (0, _vue.computed)(function() {
                            return !(0, _utils.isEmpty)(signInChoices.value.providerLabels) || signInChoices.value.ixSsoEnabled;
                        });
                        __returned__ = {
                            fetchRef: fetchRef,
                            timezone: timezone,
                            signInChoices: signInChoices,
                            get currentLocale () {
                                return currentLocale;
                            },
                            set currentLocale (v){
                                currentLocale = v;
                            },
                            ui_locales: ui_locales,
                            selectedLocale: selectedLocale,
                            waitForResponse: waitForResponse,
                            errorMessageSSO: errorMessageSSO,
                            hasProviders: hasProviders,
                            signInWith: signInWith,
                            loginIxSSO: loginIxSSO,
                            onLoginWithPassword: onLoginWithPassword,
                            PasswordBasedLogin: (0, _passwordBasedLoginVueDefault.default),
                            get $t () {
                                return 0, _translations.$t;
                            },
                            get getSelectedLocale () {
                                return 0, _translations.getSelectedLocale;
                            },
                            LocaleSelector: (0, _localeSelectorVueDefault.default)
                        };
                        Object.defineProperty(__returned__, '__isScriptSetup', {
                            enumerable: false,
                            value: true
                        });
                        return [
                            2 /*return*/ ,
                            __returned__
                        ];
                }
            });
        });
    }
});

},{"vue":"2IF1a","../ts/utils":"13wIX","../components/PasswordBasedLogin.vue":"8dgj6","../ts/translations":"kwLhN","../components/LocaleSelector.vue":"fH7Ie","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fH7Ie":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("601efbbe3efe80e9");
    if (script.__esModule) script = script.default;
    script.render = require("57258e98c2cdc8ad").render;
    script.__cssModules = require("d5fab03a70ce72b").default;
    require("29bce6837f8c2beb").default(script);
    script.__scopeId = 'data-v-8b566d';
    script.__file = "LocaleSelector.vue";
};
initialize();
exports.default = script;

},{"601efbbe3efe80e9":"5J7Nr","57258e98c2cdc8ad":"4DndS","d5fab03a70ce72b":"51xjA","29bce6837f8c2beb":"9fgHv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5J7Nr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vue = require("vue");
var _translations = require("../ts/translations");
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
exports.default = /*@__PURE__*/ (0, _vue.defineComponent)({
    __name: 'LocaleSelector',
    props: /*@__PURE__*/ (0, _vue.mergeModels)([
        'ui_locales'
    ], {
        "modelValue": {},
        "modelModifiers": {}
    }),
    emits: [
        "update:modelValue"
    ],
    setup: function(__props, _a) {
        var _this = this;
        var __expose = _a.expose;
        __expose();
        var props = __props;
        var result_ui_locales = (0, _vue.computed)(function() {
            if (!props.ui_locales) return 0, _translations.ELO_LOCALES;
            return props.ui_locales;
        });
        var selectedLocale = (0, _vue.useModel)(__props, "modelValue");
        (0, _vue.watch)(selectedLocale, function(newVal) {
            return __awaiter(_this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            console.log('selectedLocale', newVal);
                            return [
                                4 /*yield*/ ,
                                (0, _translations.setLocale)(newVal)
                            ];
                        case 1:
                            _a.sent();
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        });
        var localeLabels = {
            "cs": "\u010Cesky",
            "da": "Dansk",
            "de": "Deutsch",
            "el": "\u0395\u03BB\u03BB\u03B7\u03BD\u03B9\u03BA\u03AC",
            "en": "English",
            "es": "Espa\xf1ol (Internacional)",
            "es-419": "Espa\xf1ol (Latinoamericano)",
            "fi": "Suomi",
            "fr": "Fran\xe7ais",
            "hu": "Magyar",
            "id": "Bahasa Indonesia",
            "it": "Italiano",
            "nl": "Nederlands",
            "pl": "Polski",
            "pt": "Portugu\xeas",
            "pt-BR": "Portugu\xeas (Brasil)",
            "ro": "Rom\xe2n\u0103",
            "sk": "Slovensky",
            "sr": "Srpski",
            "sr-Cyrl": "\u0441\u0440\u043F\u0441\u043A\u0438",
            "tr": "T\xfcrk\xe7e"
        };
        var __returned__ = {
            props: props,
            result_ui_locales: result_ui_locales,
            selectedLocale: selectedLocale,
            localeLabels: localeLabels
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
});

},{"vue":"2IF1a","../ts/translations":"kwLhN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4DndS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_button = (0, _vue.resolveComponent)("b-button");
    const _component_b_dropdown_item = (0, _vue.resolveComponent)("b-dropdown-item");
    const _component_b_dropdown = (0, _vue.resolveComponent)("b-dropdown");
    return (0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_dropdown, {
        scrollable: "",
        "max-height": 300,
        position: "is-top-left",
        modelValue: $setup.selectedLocale,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$setup.selectedLocale = $event),
        "aria-role": "locale-selector"
    }, {
        trigger: (0, _vue.withCtx)(()=>[
                (0, _vue.createVNode)(_component_b_button, {
                    "data-test-id": "locale-selector",
                    class: "no-border",
                    label: "\uD83C\uDF10 " + $setup.localeLabels[$setup.selectedLocale],
                    type: "is-secondary",
                    "icon-pack": "e-icon",
                    "icon-right": "angle-down"
                }, null, 8, [
                    "label"
                ])
            ]),
        default: (0, _vue.withCtx)(()=>[
                ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)($setup.result_ui_locales, (locale)=>{
                    return (0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_dropdown_item, {
                        value: locale,
                        "aria-role": "listitem",
                        "data-test-id": 'locale-' + locale
                    }, {
                        default: (0, _vue.withCtx)(()=>[
                                (0, _vue.createTextVNode)((0, _vue.toDisplayString)($setup.localeLabels[locale]), 1)
                            ]),
                        _: 2
                    }, 1032, [
                        "value",
                        "data-test-id"
                    ]);
                }), 256))
            ]),
        _: 1
    }, 8, [
        "modelValue"
    ]);
}

},{"vue":"2IF1a","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"51xjA":[function() {},{}],"9fgHv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bVLFq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = {
    key: 0
};
const _hoisted_2 = {
    class: "bar-with-text"
};
const _hoisted_3 = {
    key: 0,
    class: "error-message"
};
const _hoisted_4 = {
    "data-test-id": "error-message-sso"
};
const _hoisted_5 = {
    key: 1,
    class: "bar-with-text"
};
const _hoisted_6 = {
    key: 2
};
const _hoisted_7 = {
    key: 0,
    class: "old-wf-links"
};
const _hoisted_8 = [
    "href"
];
const _hoisted_9 = [
    "href"
];
const _hoisted_10 = {
    key: 3,
    class: "has-text-right"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_loading = (0, _vue.resolveComponent)("b-loading");
    const _component_b_button = (0, _vue.resolveComponent)("b-button");
    const _component_b_icon = (0, _vue.resolveComponent)("b-icon");
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), null, [
        (0, _vue.createVNode)(_component_b_loading, {
            "is-full-page": "",
            modelValue: $setup.waitForResponse,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$setup.waitForResponse = $event)
        }, null, 8, [
            "modelValue"
        ]),
        $setup.hasProviders ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("section", _hoisted_1, [
            (0, _vue.createElementVNode)("div", _hoisted_2, [
                _cache[4] || (_cache[4] = (0, _vue.createElementVNode)("hr", null, null, -1)),
                (0, _vue.createElementVNode)("p", null, (0, _vue.toDisplayString)($setup.$t('sign_in_with')), 1),
                _cache[5] || (_cache[5] = (0, _vue.createElementVNode)("hr", null, null, -1))
            ]),
            ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)($setup.signInChoices.providerLabels, (pl)=>{
                return (0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_button, {
                    expanded: "",
                    type: "is-light",
                    class: "my-4",
                    onClick: ($event)=>$setup.signInWith(pl.id),
                    "data-test-id": 'button-sign_in_with_' + pl.id
                }, {
                    default: (0, _vue.withCtx)(()=>[
                            (0, _vue.createTextVNode)((0, _vue.toDisplayString)(pl.label), 1)
                        ]),
                    _: 2
                }, 1032, [
                    "onClick",
                    "data-test-id"
                ]);
            }), 256)),
            $setup.signInChoices.ixSsoEnabled ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                key: 0
            }, [
                (0, _vue.createVNode)(_component_b_button, {
                    type: "is-light",
                    class: "my-4",
                    expanded: "",
                    onClick: _cache[1] || (_cache[1] = ($event)=>$setup.loginIxSSO()),
                    "data-test-id": "button-sign_in_legacy_sso"
                }, {
                    default: (0, _vue.withCtx)(()=>[
                            (0, _vue.createTextVNode)((0, _vue.toDisplayString)($setup.signInChoices.ixSsoButtonLabel || $setup.$t('sign_in_sso') || $setup.$t('sign_in')), 1)
                        ]),
                    _: 1
                }),
                $setup.errorMessageSSO ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_3, [
                    (0, _vue.createVNode)(_component_b_icon, {
                        icon: "notification-error",
                        class: "mx-1"
                    }),
                    (0, _vue.createElementVNode)("span", _hoisted_4, (0, _vue.toDisplayString)($setup.errorMessageSSO), 1)
                ])) : (0, _vue.createCommentVNode)("", true)
            ], 64)) : (0, _vue.createCommentVNode)("", true)
        ])) : (0, _vue.createCommentVNode)("", true),
        $setup.hasProviders && $setup.signInChoices.enablePasswordLogin ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("section", _hoisted_5, [
            _cache[6] || (_cache[6] = (0, _vue.createElementVNode)("hr", null, null, -1)),
            (0, _vue.createElementVNode)("p", null, (0, _vue.toDisplayString)($setup.$t('or')), 1),
            _cache[7] || (_cache[7] = (0, _vue.createElementVNode)("hr", null, null, -1))
        ])) : (0, _vue.createCommentVNode)("", true),
        $setup.signInChoices.enablePasswordLogin ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("section", _hoisted_6, [
            (0, _vue.createVNode)($setup["PasswordBasedLogin"], {
                username: $setup.signInChoices.login_hint,
                onSuccess: _cache[2] || (_cache[2] = ($event)=>$setup.onLoginWithPassword())
            }, null, 8, [
                "username"
            ]),
            $setup.signInChoices.hasOldRegistration || $setup.signInChoices.hasOldRecovery ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("p", _hoisted_7, [
                $setup.signInChoices.legacyWfFeatures.hasRecovery ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("a", {
                    key: 0,
                    href: '../de.elo.ix.plugin.proxy/wf/apps/app/elo.webapps.Login/?mode=init_recover&lang=' + $setup.getSelectedLocale(),
                    class: "has-text-grey"
                }, (0, _vue.toDisplayString)($setup.$t('recover')), 9, _hoisted_8)) : (0, _vue.createCommentVNode)("", true),
                $setup.signInChoices.legacyWfFeatures.hasRegistration ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("a", {
                    key: 1,
                    href: '../de.elo.ix.plugin.proxy/wf/apps/app/elo.webapps.Login/?mode=init_register&lang=' + $setup.getSelectedLocale(),
                    class: "has-text-grey"
                }, (0, _vue.toDisplayString)($setup.$t('register')), 9, _hoisted_9)) : (0, _vue.createCommentVNode)("", true)
            ])) : (0, _vue.createCommentVNode)("", true)
        ])) : (0, _vue.createCommentVNode)("", true),
        $setup.ui_locales.length > 1 ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_10, [
            (0, _vue.createVNode)($setup["LocaleSelector"], {
                modelValue: $setup.selectedLocale,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event)=>$setup.selectedLocale = $event),
                ui_locales: $setup.signInChoices.ui_locales
            }, null, 8, [
                "modelValue",
                "ui_locales"
            ])
        ])) : (0, _vue.createCommentVNode)("", true)
    ], 64);
}

},{"vue":"2IF1a","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gR8fS":[function() {},{}],"hT4bd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bJIMw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createBlock)($setup["BasicLayout"], null, {
        default: (0, _vue.withCtx)(()=>[
                (0, _vue.createVNode)($setup["SignInContent"])
            ]),
        _: 1
    });
}

},{"vue":"2IF1a","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"99m3x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}]},["8yOTG"], "8yOTG", "parcelRequire94c2")

//# sourceMappingURL=sign-in.c479542e.js.map
